<!-- 专业测评报告 -->
<template>
  <!-- :style="{
          background: `url(${bgImg})`,
          'background-repeat': 'no-repeat',
          'background-size': '100% 1729px',
        }" -->
  <div class="container">
    <img class="pageImg" src="@/assets/images/home/pageBg3.png" alt="" />
    <div
      class="professionalReport"
      :style="{
        paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
      }"
    >
      <div class="navigator" :style="{background: `url(${BgImg})`,
      backgroundSize: '100% auto',
      }">
        <div class="back_share" v-if="platform == 'app'" :style="{paddingTop:`${statusBarHeight}vw`}">
          <img
            class="back_img"
            src="@/assets/images/home/back@2x.png"
            @click="back()"
            @touchmove.stop.prevent
            alt
          />
          <div>房树人测评报告</div>
          <img
            @click.stop="shareHandle()"
            class="share_img"
            src="@/assets/images/home/share.png"
            alt
          />
        </div>
        <div class="test_info">
          <div class="test_img_bg">
            <img
              class="test_img"
              src="@/assets/images/home/test_icon.png"
              alt=""
            />
          </div>
          <div class="test_info_content">
            <div class="test_name">{{ title }}</div>
            <!-- <div class="test_time">
              测评时间：
              {{ detailData.generateTime }}
            </div> -->
          </div>
        </div>
      </div>
      <div class="pageContent">
        <!-- 基础信息 -->
        <div class="content">
          <!-- 展示图片 -->
          <div class="tree_image_box" v-if="treeImageUrl">
            <img class="tree_image" :src="treeImageUrl" alt="房树人图片" />
          </div>
          <div class="content_box">
            <!-- <div
                  class="content_title_box"
                  :style="{
                    background: `url(${analyzeBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                >
                  <div
                    class="content_title"
                    :style="{
                      background: `url(${analyzeTitleBg})`,
                      'background-repeat': 'no-repeat',
                      'background-size': '100% 100%',
                    }"
                  >
                    您的心理健康指数
                  </div>
                </div> -->
            <!-- <div
              class="module_box no_border_radius"
              :style="{
                background: `url(${bgImg})`,
                'background-color': '#53CC9B',
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%',
              }"
            >
              <div class="content_title_box">
                <div class="module_content">
                  
                  <div class="chartContent">
                    <div id="GAUGE" style="width: 150px; height: 150px"></div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="module_list">
              <!-- 总结 -->
              <div class="content_conclusion2">
                <div class="content_conclusion_bg">
                  <div class="content_conclusion_text1">
                    {{ detailData.evaluateResults }}
                  </div>
                </div>
                <div class="content_conclusion_text2">
                  {{ detailData.evaluateResults }}
                </div>
              </div>
              <template v-if="detailData.wordCloudList">
                <div
                  class="content_title_box"
                  :style="{
                    background: `url(${analyzeBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                >
                  <div
                    class="content_title"
                    :style="{
                      background: `url(${analyzeTitleBg})`,
                      'background-repeat': 'no-repeat',
                      'background-size': '100% 100%',
                    }"
                  >
                    关键词
                  </div>
                </div>
                <div class="wordcloud-canvas-box">
                  <div id="wordcloud-canvas"></div>
                </div>
              </template>
              <div
                class="content_title_box"
                :style="{
                  background: `url(${analyzeBg})`,
                  'background-repeat': 'no-repeat',
                  'background-size': '100% 100%',
                }"
              >
                <div
                  class="content_title"
                  :style="{
                    background: `url(${analyzeTitleBg})`,
                    'background-repeat': 'no-repeat',
                    'background-size': '100% 100%',
                  }"
                >
                  详细解读
                </div>
              </div>
              <div
                class="module_item"
                v-for="(item, index) in detailData.angles"
                :key="index"
              >
                <div class="item_title_box">
                  <div class="title_line"></div>
                  <div class="module_item_title">{{ item.firstTitle }}方面</div>
                </div>
                <div>
                  <div
                    class="module_item_img_content"
                    v-for="(child, index) in item.children"
                    :key="index"
                  >
                    <div class="module_item_img_name">
                      {{ child.secondTitle }}
                    </div>
                    <div
                      class="module_item_img_box"
                      v-for="(content, index) in child.content"
                      :key="index"
                    >
                      <span style="color: #c1c1c1;">>></span> {{ content }}
                    </div>
                  </div>
                </div>
                <div v-if="item.type == 'TEXT'" class="module_item_text_box">
                  <div
                    class="module_item_text"
                    v-html="px2vwHtml(item.textContent)"
                  ></div>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <!-- 去聊聊 -->
            <div
              class="liao_box"
              @click="toTalk"
              :style="{
                background: `url(${liaoBg})`,
                'background-repeat': 'no-repeat',
                'background-size': '100% 100%',
              }"
            >
              <div class="liao_text">
                <div class="liao_text_title">
                  想要进一步探讨你的{{ detailData.cardCategoryTwo }}人格，
                </div>
                <div class="liao_text_title">获取更个性的建议和支持吗？</div>
              </div>
              <!-- <div class="liao_text_btn">来找朏朏聊聊吧！</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-liquidfill/src/liquidFill.js";
import { getTreeDetail,getTreeImage } from "@/api/report";
import { Toast } from "vant";
import { px2vwHtml } from "@/utils/mUtils";
import WordCloud from "wordcloud";
export default {
  data() {
    // 这里存放数据
    return {
      detailData: {},

      id: "",
      reportId: "",
      type: "",
      title: "房树人测评",
      treeImageUrl: "",
      BgImg: require("@/assets/images/home/pageBg3.png"),
      bgImg: require("@/assets/images/report/bg_p.png"),
      tagsBg: require("@/assets/images/home/tagsBg.png"),
      analyzeBg: require("@/assets/images/home/analyzeBg.png"),
      analyzeTitleBg: require("@/assets/images/home/analyzeTitleBg.png"),
      liaoBg: require("@/assets/images/report/lliaoliao_bg.png"),
      textBg: require("@/assets/images/report/text_bg.png"),
      wordcloudList:[
"珍视","期待",
"社交能力一般",
"主动社交",
"独立性低",
"服从性高",
"开放性低",
"宜人性高",
"不安担忧",
"适应能力强",
"受环境影响较低",
"自我认知一致",
"比较重视自我形象",
"自我调控能力弱",
"自我驱动强",
"情绪控制能力弱",
"抑制表达",
"直觉力",
"智力才能",
"有创造力",
"情绪温和",
"外向",
"性格坚韧"]
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    px2vwHtml,
    generateWordCloudList() {
      // 简单实现：每个词权重相同
      // return this.detailData.wordCloudList.map((word) => [
      //   word,
      //   Math.floor(Math.random() * 7) + 6,
      // ]);
      return this.wordcloudList.map(word => [word, Math.floor(Math.random() * 7) + 6 ]);
    },

    createWordCloud() {
      this.$nextTick(() => {
        const canvas = document.getElementById("wordcloud-canvas");
        if (!canvas) return;

        const list = this.generateWordCloudList();

        WordCloud(canvas, {
          list: list,
          // gridSize: 8,
          // weightFactor: 20,
          gridSize: Math.round(16 * canvas.clientWidth / 750),
          weightFactor: function (size) {
            return  Math.pow(size, 1.8) * canvas.clientWidth / 750
          },
          fontFamily: "PingFang SC, sans-serif",
          color: () => {
            const colors = [
              "#5ad8b7",
              "#79e695",
              "#5ac8d8",
              "#62DCAE",
              "#A3EDCC",
              "#A4FDCA",
              "#36b28d",
            ];
            return colors[Math.floor(Math.random() * colors.length)];
          },
          backgroundColor: "#ffffff",
          rotateRatio: 0.5,
          rotationSteps: 2,
          drawOutOfBound: false,
          shrinkToFit:true,
          // shape: "pentagon",
//           shape:function(theta) {
//   var max = 400;
//   var leng = [143,143,142,141,140,139,138,138,137,136,135,134,133,133,133,136,141,146,152,156,160,165,168,172,175,178,181,181,180,180,179,179,179,178,178,177,177,176,176,176,175,175,175,174,174,174,174,173,173,174,173,174,173,173,173,173,173,173,173,173,173,173,173,173,173,173,174,173,174,174,175,174,175,175,176,176,176,176,177,177,177,178,178,179,179,180,180,181,182,182,183,184,184,185,186,186,187,187,189,190,190,191,192,238,240,241,241,243,244,246,247,249,250,253,253,255,257,258,260,262,264,266,268,270,272,275,277,280,282,285,287,290,293,295,297,301,304,307,311,314,317,321,325,328,331,336,341,345,349,354,358,363,369,374,380,385,391,397,397,390,383,378,372,367,361,357,352,347,344,339,334,331,327,323,320,316,313,309,306,303,299,297,294,291,289,286,284,281,279,276,274,271,269,267,265,263,261,259,258,256,254,253,251,249,247,246,244,244,242,241,239,238,237,193,192,191,190,189,188,187,186,186,185,184,183,183,182,182,181,180,181,179,180,179,178,178,177,177,176,176,176,176,175,175,175,175,175,175,174,174,173,174,173,174,173,173,173,173,173,173,173,173,174,173,173,173,173,173,174,174,174,175,175,175,176,175,176,176,177,177,177,178,178,179,179,179,180,180,181,179,177,173,171,167,163,159,154,150,144,137,135,135,134,135,136,137,137,139,139,140,141,142,142,144,144,146,146,147,148,149,150,151,152,153,154,155,157,158,160,160,162,164,165,166,168,170,172,173,174,177,178,181,183,184,187,188,191,194,196,198,201,203,206,209,212,215,218,222,223,221,221,220,219,218,217,215,215,214,212,210,211,209,208,207,205,204,203,207,212,219,225,230,236,244,252,260,266,278,288,297,308,321,332,348,356,356,354,354,353,352,351,351,349,348,347,346,344,344,343,342,340,339,338,337,336,335,334,333,332,331,330,329,327,327,326,325,324,324,322,322,320,320,319,319,317,317,316,316,315,314,314,313,312,312,311,310,310,310,309,308,327,348,376,397,398,400,400,400,400,400,400,400,400,400,400,399,399,399,399,399,399,399,400,400,399,400,400,400,400,400,399,399,399,386,361,339,314,311,185,190,191,188,187,190,189,188,189,190,193,192,192,192,187,182,178,179,180,181,200,196,196,195,194,194,195,196,197,199,217,219,224,338,228,224,229,227,230,231,241,234,236,242,248,243,253,247,248,353,252,260,257,262,262,268,268,275,273,276,279,270,260,251,245,235,231,223,217,212,205,205,206,207,207,208,210,211,212,212,214,215,215,217,217,219,220,221,221,222,223,220,217,214,212,209,206,203,200,197,194,191,190,188,185,183,181,179,177,176,173,172,169,169,167,165,164,162,160,159,158,157,155,153,153,152,151,150,148,148,146,146,145,145];

//   return leng[(theta / (2 * Math.PI)) * leng.length | 0] / max;
// }

        });
      });
    },
    shareHandle() {
      const path = encodeURIComponent("Main");
      const params = {
        pageIndex: 0,
      };
      const encodeParams = encodeURIComponent(JSON.stringify(params));
      const url = `${this.$ShareUrl}/share?platform=wx&linkId=usr1jvrml77haac0&path=${path}&params=${encodeParams}`;
      let data = {
        title: this.title,
        img: "",
        url,
      };
      console.log("share - bridge", data);
      this.$bridge.call("share", data);
    },
    back() {
      this.bridgeClose();
    },
    async getTreeImageData() {
      const params = {
        businessModuleId: "",
        expiration: 60*1000,
        fileId: this.id,
        fileKey: "",
        share: true,
      };
      const res = await getTreeImage(params);
      if (res.code === 0 && res.data && res.data.fileUrl) {
        this.treeImageUrl = res.data.fileUrl.trim();
      }
    },
    async getDetailData() {
      const res = await getTreeDetail(this.id);
      const resultsArr = [];
      const results = res.data.evaluationDimensionResults;

      for (const key in results) {
        console.log("result key", key);
        const data = {
          firstTitle: key,
          children: [],
        };
        const imagesObj = results[key];
        for (const iKey in imagesObj) {
          const iData = {
            secondTitle: iKey,
            content: imagesObj[iKey],
          };
          data.children.push(iData);
        }
        resultsArr.push(data);
      }
      this.detailData = { ...res.data, angles: resultsArr };

      console.log("---detailData", res.data);
      const totalScorePercentage = res.data.mentalHealthIndex || 0;
      const chartData = {
        chartType: "GAUGE",
        chartDataType: "SUM_SCORE_PERCENT",
        data: { totalScorePercentage },
      };
      // this.detailData.generateTime = new Date(
      //   this.detailData.generateTime * 1
      // ).format("yyyy-MM-dd hh:mm");
      this.$nextTick(() => {
        this.getChartData("GAUGE", chartData);
        if (this.detailData.wordCloudList) {
          this.createWordCloud();
        }
      });
    },
    async getChartData(name, data) {
      let formatterValue = "";
      let title = "";
      if (data.chartDataType == "DIMENSION_SCORE") {
        // 各维度分数
        console.log(this.detailData.data);
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (
        data.chartDataType == "DIMENSION_SCORE_PERCENT_SIGN" ||
        data.chartDataType == "DIMENSION_SCORE_PERCENT"
      ) {
        // 各维度分数百分比
        // formatterValue = "";
        // title = data.chartTitle || "";
      } else if (
        data.chartDataType == "SUM_SCORE_PERCENT_SIGN" ||
        data.chartDataType == "SUM_SCORE_PERCENT"
      ) {
        // 总分百分比
        formatterValue =
          data.data.totalScorePercentage +
          (data.chartType == "GAUGE" ? "" : "%");
        console.log("kankan baifenbi", formatterValue);

        title = data.chartTitle || "";
      } else if (data.chartDataType == "RESULT") {
        // 结果
        formatterValue = "";
      } else if (data.chartDataType == "SUM_SCORE") {
        // 总分
        formatterValue = data.data.totalScore;
        title = "总得分";
      }
      console.log("---formatterValue", formatterValue);

      if (name == "GAUGE") {
        console.log("----看看name是不是GAUGE", name, data);
        if (
          data.chartDataType === "SUM_SCORE" ||
          data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
          data.chartDataType === "SUM_SCORE_PERCENT"
        ) {
          this.initGauge(name, data, title, formatterValue);
        } else {
          // 多个图表渲染
          if (data.data.dimensionData.length > 0) {
            data.data.dimensionData.map((d, dIdx) => {
              this.initGauge(`${name}${dIdx}`, data, d.dimension, d.score);
            });
          }
        }
      } else if (name == "WATERWAVE") {
        console.log("----看看name是不是WATERWAVE", name);
        if (
          data.chartDataType === "SUM_SCORE_PERCENT_SIGN" ||
          data.chartDataType === "SUM_SCORE_PERCENT"
        ) {
          this.initWaterWave(name, data, title, formatterValue);
        } else {
          // 多个图表渲染
          if (data.data.dimensionData.length > 0) {
            data.data.dimensionData.map((d, dIdx) => {
              this.initWaterWave(`${name}${dIdx}`, data, d.dimension, d.score);
            });
          }
        }
      } else if (name == "RADAR") {
        console.log("----看看name是不是RADAR", name, data);
        let chartDom = document.getElementById(name);
        let myChartThree = echarts.init(chartDom);
        let indicatorData = data.data.dimensionData.map((item) => {
          return {
            name: item.dimension,
            max: item.maxScore,
          };
        });
        let dimensionData = data.data.dimensionData.map((item) => {
          return item.score;
        });
        console.log(indicatorData, dimensionData);

        let option = {
          series: [
            {
              type: "radar",
              data: [{ value: dimensionData }],
              lineStyle: {
                color: "#A3EDCC",
              },
              itemStyle: {
                color: "#A3EDCC",
              },
              areaStyle: {
                color: "#A3EDCC",
              },
            },
          ],
          radar: {
            radius: "60%",
            indicator: indicatorData,
            center: ["50%", "55%"],
          },
        };
        myChartThree.setOption(option);
      }
    },
    initGauge(name, data, title, formatterValue) {
      let chartDom = document.getElementById(name);
      let myChartOne = echarts.init(chartDom);
      let option = {
        series: [
          {
            data: [
              // 数据
              {
                value: formatterValue,
                // value: 35,
                name: title || "",
              },
            ],
            title: {
              // 标题
              offsetCenter: ["0%", "120%"],
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#000",
              show: false,
            },
            detail: {
              // 详情
              valueAnimation: true,
              color: "#ffffff",
              fontStyle: "normal",
              fontWeight: "bold",
              fontFamily: "D-DIN",
              fontSize: 36,
              offsetCenter: [0, 0],
              // formatter: "{value}",
              // formatter(value) {
                // if (
                //   data.chartDataType == "SUM_SCORE_PERCENT_SIGN" ||
                //   data.chartDataType == "SUM_SCORE_PERCENT" ||
                //   data.chartDataType == "DIMENSION_SCORE_PERCENT_SIGN" ||
                //   data.chartDataType == "DIMENSION_SCORE_PERCENT"
                // ) {
                //   return value + "%";
                // } else {
                // return value + `{a|分}`;
                // }
              // },
              rich: {
                a: {
                  color: "#fff",
                  fontSize: 16,
                },
              },
            },
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            radius: "100%",
            center: ["50%", "70%"],
            splitNumber: 0, //刻度数量
            itemStyle: {
              color: "#58D9F9",
              shadowColor: "rgba(255,255,255,0.45)",
              shadowBlur: 10,
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
            progress: {
              show: true, //是否显示进度条
              width: 8,
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#ffffff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ffffff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            pointer: {
              show: false, //是否显示指针
              roundCap: true,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#79E695", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#5AD8B7", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            axisLine: {
              // 轴线
              show: false,
              roundCap: true,
              lineStyle: {
                width: 6,
              },
              color: "#A4FDCA", // 设置单一颜色为红色
            },
            axisTick: {
              // 刻度
              show: false,
            },
            splitLine: {
              // 分隔线
              show: false,
            },
            axisLabel: {
              // 刻度标签
              show: false,
            },
            anchor: {
              show: false, // 指针中心点
            },
          },
          {
            type: "gauge",
            radius: "100%",

            center: ["50%", "70%"],
            startAngle: 180,
            endAngle: 0,
            itemStyle: {
              color: "#ffffff85",
            },
            progress: {
              show: true,
              roundCap: true,

              width: 6,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: false,
            },
            data: [
              {
                value: 100,
              },
            ],
          },
        ],
      };
      myChartOne.setOption(option);
    },
    initWaterWave(name, data, title, formatterValue) {
      let chartDom = document.getElementById(name);
      let myChartTwo = echarts.init(chartDom);
      let option = {
        series: [
          {
            type: "liquidFill",
            // name: title || "",
            radius: "80%", //显示比例
            center: ["50%", "50%"], //中心点
            amplitude: 5, //水波振幅
            data: [
              formatterValue / 100,
              formatterValue / 100,
              formatterValue / 100,
            ], // data个数代表波浪数
            color: ["#A4FDCA "], //波浪颜色
            backgroundStyle: {
              borderWidth: 6, //外边框
              borderColor: "#A4FDCA ", //边框颜色
              color: "#62DCAE", //边框内部填充部分颜色
            },
            label: {
              //标签设置
              position: ["50%", "50%"],
              // formatter(value) {
              //   return title + "\n\n" + formatterValue;
              // }, //显示文本,
              formatter: formatterValue,
              fontSize: "20px", //文本字号,
              color: "#fff",
            },
            outline: {
              show: false, //最外层边框显示控制
            },
            title: {
              // 标题
              offsetCenter: ["0%", "120%"],
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#ff00ff",
              show: true,
            },
          },
        ],
      };
      myChartTwo.setOption(option);
    },
    // 跳转小程序聊聊
    toTalk() {
      if (this.platform === "app") {
        this.bridgeRoute({
          path: "Main",
          params: JSON.stringify({ pageIndex: 2 }),
        });
      } else if (this.platform === "wx") {
        this.$wx.miniProgram.navigateTo({ url: `/pages/index/home?index=2` });
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.id = this.$route.query.id;
    this.reportId = this.$route.query.reportId;
    this.type = this.$route.query.type;
    // this.title = this.$route.query.title;
    this.getDetailData();
    this.getTreeImageData();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {},
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variable.scss";
$ListHeight: calc(100vh - 120px);
.container {
  color: #333333;
  height: 100vh;
  /* background-color: #f3f4f6; */
  background: linear-gradient(180deg, #5ad8b7, #f3f4f6);
}
.pageImg {
  width: 100%;
  position: fixed;
  /* top: -660px; */
  left: 0;
}
.professionalReport {
  overscroll-behavior: none;
  overflow-y: auto;
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  /* background-color: #f3f4f6; */
  /* padding-bottom: 220px; */

  .navigator {
    width: 100vw;
    /* height: 85px; */
    color: #292929;
    position: fixed;
    top: 0px;
    left: 0;
    z-index: 2;
    .back_share {
      width: 100%;
      padding: 18px 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .back_img {
        width: 21px;
        height: 38px;
      }
      .nav_title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #292929;
        line-height: 72px;
      }
      .share_img {
        width: 38px;
        height: 38px;
      }
    }
    .test_info {
      display: flex;
      align-items: center;
      padding: 18px 36px;
      .test_img_bg {
        width: 70px;
        height: 70px;
        background-color: #ffffff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        .test_img {
          width: 70px;
          height: 70px;
        }
      }
      .test_info_content {
        .test_name {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #292929;
        }
        .test_time {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #292929;
        }
      }
    }
  }
  .pageContent {
    /* overscroll-behavior: none; */
    flex: 1;
    width: 100%;
    /* height: 100vh; */
    /* overflow-y: auto; */
    padding-top: 250px;
    /* padding-top: 618px; */
    /* position: absolute; */
    /* bottom: 0px; */
    /* left: 0; */
    .content {
      padding: 0 18px;
      background: linear-gradient(transparent 10%, #f3f4f6 35%, #f3f4f6 100%);

      .tree_image_box {
        width: 100%;
        margin-bottom: 60px;
        border-radius: 20px;
        overflow: hidden;
        background: #ffffff;
        .tree_image {
          width: 100%;
          display: block;
        }
      }

      .result_type_box {
        margin: 0 auto;
        margin-top: 100px;
        margin-bottom: 50px;
        width: fit-content;
        text-align: center;
        .result_type_top {
          position: relative;
          display: inline-block;
          padding: 20px 0px 0px 20px;
          .result_icon {
            width: 59px;
            height: 22px;
            position: absolute;
            top: 0;
            right: -24px;
          }
          .result_type {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 33px;
            background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .result_type_bottom {
          position: relative;
          padding: 0px 20px 20px 30px;
          .result_subtitle {
            font-family: Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 49px;
            background: linear-gradient(164deg, #79e695 0%, #5ac8d8 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .left_icon {
            width: 53px;
            height: 30px;
            position: absolute;
            left: 0px;
            bottom: 0;
          }
        }
      }
      .tags_box {
        padding: 30px 40px;
        margin-bottom: 21px;
        .tags_title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 36px;
          color: #36b28d;
          margin-left: 8px;
        }
        .tags_list {
          .tags_item {
            display: flex;
            margin-top: 22px;
            .tags_text {
              position: relative;
              padding: 0 15px;
              font-family: PingFang SC;
              font-weight: bold;
              font-size: 26px;
              color: #222222;
              line-height: 1.5; /* 确保文本不会与背景重叠 */
              z-index: 2; /* 确保背景在文本后面 */
            }

            .tags_text::before {
              content: "";
              position: absolute;
              bottom: -2px;
              left: 0;
              width: 100%;
              height: 50%; /* 背景颜色占一半高度 */
              background-color: var(--tag-color); /* 使用 CSS 变量 */
              border-top-left-radius: 8px; /* 左上角圆角 */
              border-top-right-radius: 8px; /* 右上角圆角 */
              border-bottom-left-radius: 8px; /* 左上角圆角 */
              border-bottom-right-radius: 8px; /* 右上角圆角 */
              z-index: -1; /* 确保背景在文本后面 */
            }
            // .tags_text {
            //   padding: 0 15px;
            //   font-family: PingFang SC;
            //   font-weight: bold;
            //   font-size: 26px;
            //   color: #222222;
            // }
          }
        }
      }
      .content_box {
        background: #ffffff;
        border-radius: 30px;
        .module_box {
          //   margin-bottom: 23px;
          border-top-left-radius: 30px;
          border-top-right-radius: 30px;
          &.no_border_radius{
            border-radius: 0 ;
          }
          .content_title_box {
            padding: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            /* background: linear-gradient(180deg, #5ad8b7, #88f5d8); */
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            .content_title {
              width: 307px;
              height: 62px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 32px;
              color: #222222;
            }
          }
          .module_content {
            padding: 23px 21px;
            text-align: center;
            // background-color: #ffffff;
            .content_description {
              padding: 21px 18px 23px 22px;
              background: #f5faf9;
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #282828;
            }
            .chartContent {
              margin-top: 40px;
              #chartOne {
                // margin-left: 150px;
              }
              #chartTwo {
                // margin-left: 150px;
              }
            }
            .charts_desc {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #282828;
              margin-top: 46px;
            }
            .dimensionTitle {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 40px;
              color: #ffffff;
              /* margin-top: 46px; */
            }
          }
        }
        .module_list {
          background: #ffffff;
          border-top-left-radius: 30px;
          border-top-right-radius: 30px;
          margin-top: -30px;
          .module_item {
            margin-bottom: 50px;
            .item_title_box {
              display: flex;
              align-items: center;
              padding: 25px 20px 20px 20px;
              .title_line {
                width: 5px;
                height: 25px;
                background: #fade22;
                border-radius: 2px;
                margin-right: 15px;
              }
              .module_item_title {
                font-family: PingFang SC;
                font-weight: bold;
                font-size: 28px;
                color: #222222;
              }
            }
            .module_item_img_content {
              .module_item_img_name {
                font-weight: 700;
                font-size: 24px;
                padding: 7px 27px 12px 18px;
                display: inline-block;
                background: linear-gradient(90deg, #ffffff 0%, #a4fdca 100%);
                border-radius: 0px 22px 22px 0px;
              }
              .module_item_img_box {
                margin-top: 20px;
                font-size: 24px;
                /* line-height: 40px; */
                color: #282828;
                padding: 0px 20px 0px 20px;
                margin-bottom: 24px;
                .module_item_img {
                  width: 100%;
                  height: 100%;
                  margin-top: 22px;
                  padding-bottom: 22px;
                  border-bottom: 1px dashed #ededed;
                }
              }
            }
            .module_item_img_content:last-child {
              .module_item_img_box {
                margin-bottom: 0;
                .module_item_img {
                  border-bottom: 1px solid #ededed;
                }
              }
            }
            .module_item_text_box {
              padding: 0px 20px 20px 20px;
              .module_item_text {
                padding-bottom: 20px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #282828;
                border-bottom: 1px solid #ededed;
              }
            }
          }
          .content_conclusion2 {
            position: relative;
            padding-bottom: 20px;
            padding-top: 20px;
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            .content_conclusion_bg {
              width: calc(100% - 20px);
              margin-left: 20px;
              padding: 14px 0 0 16px;
              background: linear-gradient(90deg, #9ee0c3 0%, #ffffff 46%);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #222222;
            }
            .content_conclusion_text1 {
              width: 648px;
              box-sizing: border-box;
              padding: 42px 14px 20px 16px;
              box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              line-height: 40px;
              color: transparent;
            }
            .content_conclusion_text2 {
              width: 648px;
              box-sizing: border-box;
              padding: 42px 14px 37px 16px;
              background: #ffffff;
              box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              line-height: 40px;
              color: #222222;
              position: absolute;
              top: 14px;
              left: 36px;
            }
          }
        }
      }
    }
    .liao_box {
      width: 713px;
      height: 211px;
      padding: 75px 45px 31px 65px;
      margin-bottom: 30px;
      .liao_text {
        width: 367px;
        height: 75px;
        text-align: center;
        .liao_text_title {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #222222;
        }
      }
      .liao_text_btn {
        font-family: Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #54c394;
        margin-left: 47px;
      }
    }
  }
}

.wordcloud-canvas-box {
  padding: 10px;
  #wordcloud-canvas {
    width: 100%;
    min-height: 400px;
  }
}
.content_title_box {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  .content_title {
    width: 307px;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 32px;
    color: #222222;
  }
}
</style>
